import { useState, ChangeEvent, FormEvent, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { colors } from 'styles/GlobalStyles';
import { H2, P1, P2 } from '../../../styles/FontStyles';
import { Div, Separator } from '../../../styles/Styles';
import { FormTitle } from '../Auth.styled';
import { InputComponent } from 'components/Input/Input';
import { Button } from 'components/Button/Button';
import { GoogleButton } from '../GoogleButton';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { signIn } from 'services/auth/auth.service';
import Spinner from 'components/Spinner/Spinner';
import { removeUserFromLS } from 'helpers/localstorage-helper';
import { removeUserFromState } from 'slices';

export const SignIn = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { loading } = useAppSelector((state) => state.authentication);

  const onFormSubmit = (e: FormEvent) => {
    e.preventDefault();

    dispatch(
      signIn({
        email,
        password,
        navigate,
      })
    );
  };

  useEffect(() => {
    removeUserFromLS();
    dispatch(removeUserFromState());
  }, [dispatch]);

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}
      <H2 center m='50px 0' color={colors.primary}>
        Welcome Back!
      </H2>
      <P1 color={colors.white} center mb='40'>
        Log in to access your account and explore new features!
      </P1>
      <form onSubmit={onFormSubmit}>
        <InputComponent
          placeholder='Enter email'
          type='email'
          label='Email address'
          value={email}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setEmail(e.target.value)
          }
        />
        <InputComponent
          placeholder='Type in password'
          type='password'
          label='Your Password'
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
        />
        <Div $flex $justifyEnd>
          <P2
            color={colors.white}
            onClick={() => navigate('/auth/reset-password')}
            style={{ cursor: 'pointer' }}
          >
            Forgot your password?
          </P2>
        </Div>

        <Button style={{ marginTop: 20 }} type='submit'>
          Sign In
        </Button>
      </form>
      <Separator $m='30px 0' />
      <GoogleButton />
    </>
  );
};
